export default "__VITE_ASSET__CyeVH5SG__"